import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    const videoBgEl = document.querySelectorAll('.handle-bg__video');
    if (videoBgEl.length > 0) {
        const { initVideo } = await import(new URL('../components/video.js', import.meta.url).href);
        initVideo();
        let timeout;
        window.addEventListener('resize', function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                initVideo();
            }, 300);
        });
    }

    const scrollSlideEls = document.getElementById("handle-voice__slide");
    if (scrollSlideEls) {
        const { renderSwiperVoice } = await import("../components/swiper.js");
        renderSwiperVoice(scrollSlideEls);
    }

    const searchSlideEls = document.getElementById("handle-search__slide");
    if (searchSlideEls) {
        const { renderSwiperSearch } = await import("../components/swiper.js");
        renderSwiperSearch(searchSlideEls);
    }
    const loadMoreEl = document.querySelectorAll('.handle-load-content');
    if (loadMoreEl) {
        const { initLoadMore } = await import('../components/load-more.js');
        initLoadMore();
    }

    const anchorEl = document.querySelectorAll('.handle-anchor');
    if (anchorEl) {
        const { initAnchorLink } = await import('../components/anchorlink.js');
        initAnchorLink();
    }

    const openCampusTtlEls = document.getElementById("slider-opencampus-ttl");
    if (openCampusTtlEls) {
        const { renderOpenCampusTtlSlide } = await import("../components/slider.js");
        renderOpenCampusTtlSlide(openCampusTtlEls);
    }

    const openCampusCalendar = document.getElementById("handled-calendar-campus");
    if (openCampusCalendar) {
        const { toggleSelectedClass, addEventLoad, activeCurDay } = await import("../components/calendar-campus.js");
        addEventLoad();
        toggleSelectedClass();
        activeCurDay();
    }

    const floatEls = document.querySelectorAll(".ctrl--floatY");
    if (floatEls) {
        const { initFloatY } = await import("../components/float.js");
        initFloatY();
    }

    const { scrollSticky } = await import('../components/scroll-sticky-bottom.js');
    scrollSticky();

    const { trackConversion } = await import('../components/popup-banner.js');
    trackConversion();

    const subjectFilterButtons = document.querySelectorAll('#subject-filter .e-btn--ctrl');
    const openCampusBlocks = document.querySelectorAll('.c-block__detail');
    if (!subjectFilterButtons.length) return;

    subjectFilterButtons.forEach(button => {
        button.addEventListener('click', () => {
            subjectFilterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
            const selectedSubjectId = button.dataset.subjectId;
            openCampusBlocks.forEach(block => {
            block.style.display =
                !selectedSubjectId || block.dataset.subjectIds.split(',').includes(selectedSubjectId)
                ? ''
                : 'none';
            });
        });
    });
});
